import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
/**
 * @Description This function returns Delete Selection dialog.
 * @Returns     Component
 * @Author      ibrahim AKIN
 */
function DeleteDialog({ open, setOpen, onDelete }) {
    const { t } = useTranslation();
    const label = 'CONTENT.VARIANTS.';
    const handleClose = () => { setOpen(null); };
    const handleDelete = () => { onDelete(open); setOpen(null); };
    return (
        <Dialog maxWidth="xs" onClose={handleClose} open>
            <DialogTitle>
                <div className="dialog-header variant">
                    {t(label + 'WARNING')}
                    <Button onClick={handleClose}>
                        <Close fontSize="small" />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div className="dialog-body">
                    <div>{t(label + 'DELETE-CONFIRM')}</div>
                    <Button onClick={handleDelete}>{t(label + 'YES')}</Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}
export default DeleteDialog;